<div class="modal-heading" [class.title-hidden]="hideTitle" [class.compact]="compact">
  <button type="button" class="modal-heading-close" [attr.aria-label]="closeLabel"
    [disabled]="closeDisabled" (click)="closed.emit()">
    <mat-icon aria-hidden="true">close</mat-icon>
  </button>
  <div *ngIf="!hideTitle && !compact" class="modal-heading-icon" aria-hidden="true"><mat-icon>{{ icon }}</mat-icon></div>
  <h2 mat-dialog-title [id]="titleId" class="modal-heading-title">{{ title }}</h2>
</div>
